@if(department(); as department;){

<common-icon-text iconStyle='fa-solid' [icon]="department.icon" [text]="department.name" spacing="large"
	iconSize="large">
</common-icon-text>

}
@else {
<div class="d-flex align-items-center ps-1">Missing Department</div>
}